const shared = {
  paddingX: 3,
  paddingY: 3,
  labelWidth: 150,
  // controlWidth: 200,
}

const LIGHT_THEME = {
  ...shared,
  backgroundColor: '#EEE',
  lowlight: '#DDD',
  lowlighterr: '#FBB',
  highlight: '#444',
  separator: '1px solid #DDD',
  label: {
    fontColor: '#444',
    fontWeight: 'normal'
  }
}

const DARK_THEME = {
  ...shared
}

module.exports = {
  LIGHT_THEME,
  DARK_THEME,
}